<template>
    <base-file-input
        v-model="model"
        v-validate="{
            required: field.isRequired,
        }"
        :required="field.isRequired"
        :field="field"
        input-id="evidence"
        input-label="Source of funds Evidence Document"
        :placeholder="
            originalFileName || 'Select scan copy (JPG, PNG or TIFF file)'
        "
        drop-placeholder="Drop file here..."
        file-type="utility"
        accept="image/*"
        data-vv-name="Source of funds Evidence"
        :class="{
            'is-invalid': errors.has('Source of funds Evidence'),
        }"
        @update:originalFileName="updateOriginalFileName"
    ></base-file-input>
</template>

<script>
import IdentityDocument from './IdentityDocument'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: IdentityDocument, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > components

    created() {
        // if (this.field.key == 'sourceOfFunds.evidenceDocument.fileName') {
        //     this.$store.watch(
        //         (state) => {
        //             return this.$store.state.registration.form.sourceOfFunds
        //                 .evidenced
        //         },
        //         (newValue) => {
        //             console.log('Textarea Sourec of Wealth: ', newValue)

        //             if (newValue && newValue.length && newValue.length > 0) {
        //                 newValue.forEach((element) => {
        //                     if (element != 'Not Applicable') {
        //                         this.field.isRequired = true
        //                     } else {
        //                         this.field.isRequired = false
        //                     }
        //                 })
        //             }
        //         }
        //     )
        // }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: false,
                    isLocked: true,
                    key: 'sourceOfFunds.evidenceDocument.fileName',
                    originalFileNameKey:
                        'sourceOfFunds.evidenceDocument.originalFileName',
                }
            },
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        console.log("field.isRequired Source of funds document .vue",this.field.isRequired)
        // if (this.field.key == 'sourceOfFunds.evidenceDocument.fileName') {
        //     // if (this.$store.state.registration.form.sourceOfFunds.evidenced) {
        //     const element =
        //         this.$store.state.registration.form.sourceOfFunds.evidenced
        //     // }
        //     if (element && element != 'Not Applicable') {
        //         this.field.isRequired = true
        //     } else {
        //         this.field.isRequired = false
        //     }
        // }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
